@use "@fukuri-admins/ui/layout" as *;

.fileInputWrapper {
  display: flex;
  flex-direction: column;
  gap: spacing('8');
}

.hiddenFileInput {
  display: none;
}

.fileInputLabel {
  display: inline-flex;
  padding: spacing('8') spacing('12');
  border: 1px solid border('Quaternary');
  background-color: transparent;
  color: text('High');
  border-radius: borderRadius('md');
  gap: spacing('8');
  cursor: pointer;
  text-align: center;
  transition: border-color 0.2s;

  .fileInputLabelText {
    @include typography('Jp/12_W6');
  }

  .fileInputPlaceholder {
    @include typography('Jp/12_W3');
  }

  &.error {
    border-color: border('Red_Darken');
  }
}

.fileSelectedContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: spacing('8') spacing('12');
  border: 1px solid border('Quaternary');
  border-radius: borderRadius('md');
  background-color: transparent;

  &.error {
    border-color: border('Red_Darken');
  }
}

.fileName {
  @include typography('Jp/12_W3');
  color: text('High');
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.removeButton {
  background: none;
  border: none;
  cursor: pointer;
  color: text('Low');
  font-size: 20px;
  padding: 0;
  margin-left: spacing('8');

  &:hover {
    color: text('High');
  }
}
